import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

import { BehaviorSubject } from 'rxjs'

import { EGuardEntityName, EGuardSectionName } from '~/core/models'

@Component({
  selector: 'app-user-access-block',
  templateUrl: './user-access-block.component.html',
  styleUrl: './user-access-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatIconModule],
})
export class UserAccessBlockComponent {
  private grantedPermissionSectionEntities:
    | {
        [key: string]: {
          [key: string]: {
            [key: string]: boolean
          }
        }
      }
    | null
    | undefined

  private grantedSectionName: EGuardSectionName | null | undefined
  private grantedEntityName: EGuardEntityName | null | undefined
  private grantedEntityField: string | null | undefined

  readonly permissionSectionEntities = input<
    | {
        [key: string]: {
          [key: string]: {
            [key: string]: boolean
          }
        }
      }
    | null
    | undefined
  >(null)

  readonly sectionName = input<EGuardSectionName | null | undefined>(null)
  readonly entityName = input<EGuardEntityName | null | undefined>(null)
  readonly entityField = input<string | undefined>(undefined)

  readonly isGranted$ = new BehaviorSubject<boolean>(false)

  constructor() {
    effect(() => {
      this.grantedPermissionSectionEntities = this.permissionSectionEntities()
      this.setGrantedStatus()
    })

    effect(() => {
      this.grantedSectionName = this.sectionName()
      this.setGrantedStatus()
    })

    effect(() => {
      this.grantedEntityName = this.entityName()
      this.setGrantedStatus()
    })

    effect(() => {
      this.grantedEntityField = this.entityField()
      this.setGrantedStatus()
    })
  }

  setGrantedStatus(): void {
    if (
      !this.grantedPermissionSectionEntities ||
      !this.grantedSectionName ||
      !this.grantedEntityName ||
      !this.grantedEntityField
    ) {
      return
    }

    const isGranted = Boolean(
      this.grantedPermissionSectionEntities[this.grantedSectionName][this.grantedEntityName][
        this.grantedEntityField
      ]
    )

    if (isGranted !== this.isGranted$.value) {
      this.isGranted$.next(isGranted)
    }
  }
}
